<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgSalesPlatformReview',
  components: {
    PageTable,
  },
}
</script>